<template>
    <button
        type="button"
        :class="['a-text-button', themeCssClass]"
        @click="onClick"
    >
        <svg-icon
            v-if="isLeftIcon"
            :name="`icons/${icon}`"
            original
            class="text-button-icon"
        />
        <span class="text-button-title">
            {{ text }}
        </span>
        <svg-icon
            v-if="isRightIcon"
            :name="`icons/${icon}`"
            original
            class="text-button-icon"
        />
    </button>
</template>

<script>
import { computed } from '@vue/composition-api';

export default {
    name: 'ATextButton',
    props: {
        text: {
            type: String,
            default: ''
        },
        icon: {
            type: String,
            default: ''
        },
        iconPosition: {
            type: String,
            default: 'right',
            validator: val => ['right', 'left'].includes(val)
        },
        theme: {
            type: String,
            default: '',
            validator: val => ['', 'black'].includes(val)
        }
    },
    setup(props, { emit }) {
        const isLeftIcon = computed(() => props.iconPosition === 'left');
        const isRightIcon = computed(() => props.iconPosition === 'right');
        const themeCssClass = computed(() => {
            return props.theme ? `text-button-${props.theme}` : null; 
        });

        function onClick() {
            emit('onClick')
        }

        return {
            isLeftIcon,
            isRightIcon,
            themeCssClass,
            onClick
        };
    }
}
</script>

<style lang="scss" src="./theme.scss" />